import { type ReactNode } from "react";
interface GxButtonWhiteXLProps {
  children: ReactNode;
  onClick: () => void;
}
const GxButtonWhiteXL = ({ children, onClick }: GxButtonWhiteXLProps) => {
  return (
    <button onClick={onClick} className="gx-button-white-xl">
      {children}
    </button>
  );
};

export default GxButtonWhiteXL;
